import React from 'react';
import { tw } from 'twind';

import { ActiveCart } from 'types/cart';
import { isNumber } from 'utils/isNumber';
import { Adjustment, CartPromoFieldsFragment } from '__generated__/graphql';

import { Price } from './Price';

export const CartAppliedPromotions: React.FC<{
  cart?: ActiveCart;
  className?: string;
}> = props => {
  const { cart, className } = props;

  const adjustments: Adjustment[] = [];
  //Should show only order/shipping lvl promotions and not coupon based
  cart?.orderAdjustments &&
    adjustments.push(
      ...(cart as CartPromoFieldsFragment).orderAdjustments.filter(
        p => !p.couponCode
      )
    );
  cart?.shippingAdjustments &&
    adjustments.push(...cart.shippingAdjustments.filter(p => !p.couponCode));

  if (!adjustments.length) {
    return null;
  }

  const adjustmentsFiltered = adjustments.filter(
    adj => adj.promotionId !== 'codFee'
  );

  return (
    <ul className={tw('font-bold text-puma-black-100', className)}>
      {adjustmentsFiltered.map(({ promotionId, itemText, price }) => (
        <li key={promotionId} data-test-id="cart-applied-promotion">
          <p className="flex justify-between whitespace-nowrap normal-case font-normal">
            <span
              className="whitespace-normal"
              data-test-id="cart-applied-promo-callout"
            >
              {itemText}
            </span>
            <span
              className="text-puma-green"
              data-test-id="cart-applied-promo-adjustment"
            >
              {isNumber(price) && <Price amount={price} />}
            </span>
          </p>
        </li>
      ))}
    </ul>
  );
};
